import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/return_item_company/createaction";
import Return_item_companylist from "./return_item_companylist";
import getitemaction from "../../context/action/return_item_company/getitemaction";
import numberbeautify from "../../utils/numberbeautify";
import { MdDeleteForever } from "react-icons/md";

const Return_item_company = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
  const [barcode, setbarcode] = useState();
  const [company_return_date, setcompany_return_date] = useState();
  const [company_return_note, setcompany_return_note] = useState("");
  const [company_id, setcompany_id] = useState();
  const [items, setitems] = useState([]);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">گەڕاندنەوەی کاڵا</h1>
          <p className="text-sm text-slate-400 mt-0.5">گەڕاندنەوەی کاڵا بۆ کۆمپانیا</p>
        </div>
      </div>

      {/* Add Broke Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
        <div className="w-full">
          <label
            className={
              error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            کۆمپانیای دابینکەر
          </label>
          <select
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            value={company_id}
            onChange={(val) => {
              setcompany_id(val.target.value);
              seterror(false);
            }}
          >
            <option value="">کۆمپانیا</option>
            {initState.company.map((lis) => (
              <option key={lis.company_id} value={lis.company_id}>
                {lis.company_name}
              </option>
            ))}
          </select>
        </div>

        {/* Date Input */}
        <div className="w-full">
          <label
            className={
              error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            بەروار
          </label>
          <input
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            type="date"
            value={company_return_date}
            onChange={(val) => setcompany_return_date(val.target.value)}
            onFocus={() => seterror1(false)}
          />
        </div>

        {/* Note Input */}
        <div className="w-full">
          <label 
            className={
              "block text-sm font-medium text-slate-500 mb-1 text-right"
            }>
            تێبینی
          </label>
          <input
            className={
              "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            type="text"
            value={company_return_note}
            onChange={(val) => setcompany_return_note(val.target.value)}
          />
        </div>

        {/* Submit Button */}
        <div className="w-full">
          <button
            disabled={!items.length}
            className={items.length?"h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full":"h-10 px-6 bg-indigo-300 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full cursor-not-allowed"}
            onClick={() => {
              if (!company_id || company_id == "") {
                seterror(true);
                return false;
              }
              if (company_return_date?.trim() == "" || !company_return_date) {
                seterror1(true);
                return false;
              }
              createaction(
                company_id,
                company_return_date,
                company_return_note,
                initState.token.id,
                items
              )(recaller)(setrecaller)(initDispatch)(clear);
            }}
          >
            گەڕاندنەوە
          </button>
        </div>
      </div>
      </div>

      {/* Barcode Scanner Section */}
      <div className="w-full mt-8">
        <div className="bg-gray-400 rounded-lg p-4 sm:p-6">
          <div className="w-full mx-auto">
            <label className="block text-base font-medium text-white mb-1 text-right">
              باڕکۆد
            </label>
            <input
              className="w-full h-12 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              type="text"
              value={barcode}
              onChange={(val) => setbarcode(val.target.value)}
              autoFocus
              onKeyDown={(key) => {
                if (key.key === "Enter") {
                  getitemaction(barcode)(recaller)(setrecaller)(items)(setitems)(setbarcode);
                }
              }}
            />
          </div>
        </div>
      </div>

      {/* Items Table */}
      {items.length > 0 && (
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto mt-6">
        
          {/* Section Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
            <h2 className="text-base font-semibold text-slate-800">-</h2>
          </div>

          {/* Table */}
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-100">
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  ناوی کاڵا
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  باڕکۆد
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  نرخ
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  عەدەد
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  کۆی نرخ
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  ڕەشکردنەوە
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {items.map((lis, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {lis.item_name}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {lis.item_barcode}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    <input
                      className={
                        "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                      }
                      id="grid-last-name"
                      type="number"
                      value={lis.item_price}
                      onClick={(val) => {
                        val.target.select();
                      }}
                      onChange={(val) => {
                        setitems(
                          items.map((lis, indexx) =>
                            index == indexx
                              ? {
                                  item_id: lis.item_id,
                                  service_id: lis.service_id,
                                  item_name: lis.item_name,
                                  item_barcode: lis.item_barcode,
                                  item_price: val.target.value,
                                  item_qty: lis.item_qty,
                                }
                              : lis
                          )
                        );
                        // setstopsell(false);
                      }}
                    />
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    <input
                      className={
                        "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                      }
                      id="grid-last-name"
                      type="number"
                      value={lis.item_qty}
                      onClick={(val) => {
                        val.target.select();
                      }}
                      onChange={(val) => {
                        setitems(
                          items.map((lis, indexx) =>
                            index == indexx
                              ? {
                                  item_id: lis.item_id,
                                  service_id: lis.service_id,
                                  item_name: lis.item_name,
                                  item_barcode: lis.item_barcode,
                                  item_price: lis.item_price,
                                  item_qty: val.target.value,
                                }
                              : lis
                          )
                        );
                      }}
                    />
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {numberbeautify(
                      Number(lis.item_qty) * Number(lis.item_price)
                    )}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <MdDeleteForever
                        size={28}
                        color="#e74c3c"
                        className="cursor-pointer"
                        onClick={() => {
                          setitems(
                            items.filter(
                              (list) => list.item_id != lis.item_id
                            )
                          );
                        }}
                      />
                  </td>
                </tr>
              ))}
              <tr>
                <th
                  className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                  colSpan={3}
                >
                  کۆی گشتی
                </th>
                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                  {numberbeautify(
                    items.reduce(
                      (a, v) =>
                        (a =
                          Number(a) +
                          Number(v.item_price) * Number(v.item_qty)),
                      0
                    )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Items List */}
      <div className="mt-8">
        <Return_item_companylist />
      </div>
    </div>
  );
};

export default Return_item_company;